// نسخه متصل‌شده به بک‌اند برای ProfileOrders و نمایش سفارشات واقعی

import React, { useEffect, useState } from "react";
import LoadingSpinner from "../components/common/LoadingSpinner";
import { httpReauest } from "../utils/httpRequest";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "iconsax-reactjs";
import Layout from "../components/layout";
import { ShoppingBag } from "iconsax-reactjs";
import { useTranslation } from "react-i18next";
import OrderCard from "../components/common/card/OrderCard";

const ProfileOrders = () => {
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);

  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    getOrders();
  }, []);

  async function getOrders() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return navigate("/login");

    try {
      const res = await httpReauest(
        "GET",
        `/order/user/${user._id}`,
        {},
        { "x-access-token": user.token }
      );
      setOrders(res.data.data || []);
    } catch (err) {
      console.error("خطا در دریافت سفارش‌ها", err);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <LoadingSpinner />;

  return (
    <div className="min-h-screen flex flex-col px-4">
      <div className="flex justify-end py-4">
        <Link to="/profile">
          <ArrowLeft />
        </Link>
      </div>
      <div className="flex justify-between items-start px-3 py-2 bg-white shadow rounded-[8px]">
        <div className="flex gap-2 items-center">
          <ShoppingBag size={22} />
          {t("nav_orders")}
        </div>
      </div>
      <div className="py-4 grid gap-3">
        {orders.length === 0 ? (
          <p className="text-center text-sm text-gray-500">{t("no_orders")}</p>
        ) : (
          orders.map((order) => <OrderCard key={order._id} order={order} />)
        )}
      </div>
    </div>
  );
};

export default ProfileOrders;
